export default {
    install(Vue, options = null){
        Vue.directive('intOnly', (el) => {
            el.addEventListener('keypress', (evt) => {
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            });
            el.addEventListener('focus', (e) => {
                e.target.select();
            });
        });

        Vue.directive('decimalOnly', (el) => {
            el.addEventListener('keypress', (evt) => {
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            });
            el.addEventListener('focus', (e) => {
                e.target.select();
            });
        });

        Vue.directive('selectText', (el) => {
            el.addEventListener('focus', (e) => {
                e.target.select();
            });
        });
    }
}